import GetDeliveryAddressRequestModelBase from '../_generated/modelBases/get-delivery-address-request-model-base';

export default class GetDeliveryAddressRequestModel extends GetDeliveryAddressRequestModelBase {
  // For instructions on how to use Models visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/429/ServiceModels-DTOs
}
